export default "__VITE_ASSET__BhxLv3lp__"